import { c as _c } from "react/compiler-runtime";
export const VaultTransactionsPartialNotice = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p data-testid="vault-transactions-partial-notice" className="text-secondary-foreground text-sm">Some transactions could not be loaded, so this page may be incomplete.</p>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};